import { PossibleQuestion, Question, QuestionBody } from '../interfaces/surveyScreen';
import { routeMappings } from '../../constants/routeMappings';
import { surveyTypes, DOMAINS_NOT_MAPPED, ECS_DOMAIN } from '../constants/shl360';
import { WorkflowItem } from '../../store/interfaces';

const playerApiDomain = process.env.REACT_APP_PLAYER_API_DOMAIN || '';

export const getCleanLabels = (value: string): string => {
  if (value.indexOf(': ') > -1) {
    value = value.split(': ')[1];
  }
  return value;
};

export const flatQusData = (data: Question): PossibleQuestion[] => {
  const qus: Array<PossibleQuestion> = [];
  let qusArray: PossibleQuestion[] = [];
  /* as we can get any type of survey questions */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const qBody: QuestionBody | any = data.questionBody || {};
  const availableSections = Object.keys(qBody);
  qus.push({ type: surveyTypes.TIPS, data: data.tips });
  if (availableSections.indexOf('questionnaires') > -1) {
    qus.push({ type: surveyTypes.INTRO, data: surveyTypes.QU });
    qus.push(...qBody.questionnaires);
  }
  if (availableSections.indexOf('importanceRatings') > -1) {
    qus.push({ type: surveyTypes.INTRO, data: surveyTypes.IR });
    qus.push(...qBody.importanceRatings);
  }
  if (availableSections.indexOf('multiChoices') > -1) {
    qus.push({ type: surveyTypes.INTRO, data: surveyTypes.AD });
    qus.push(...qBody.multiChoices);
  }
  if (availableSections.indexOf('openQuestions') > -1) {
    if (availableSections.indexOf('multiChoices') < 0) {
      qus.push({ type: surveyTypes.INTRO, data: surveyTypes.AD });
    }
    qus.push(...qBody.openQuestions);
  }
  qusArray = qus;
  return qusArray;
};

export const getRouteMfsTaskListPage = (currentWorkflowItem: WorkflowItem): string =>
  `${routeMappings[currentWorkflowItem.code]}/${currentWorkflowItem.id}`;

export const scrollToBottom = (): void => {
  const scrollingElement = document.scrollingElement || document.body;
  scrollingElement.scrollTop = scrollingElement.scrollHeight;
};

export const getServerDomain = (value: string): string => {
  if (playerApiDomain === '') {
    value = window.location.origin + value;
  }
  if (DOMAINS_NOT_MAPPED.indexOf(window.location.origin) > -1) {
    value = value.replace(window.location.origin, ECS_DOMAIN);
  }
  return value;
};

export const downloadFile = (fileURL: string, fileName: string): void => {
  const save = document.createElement('a');
  save.href = fileURL;
  save.target = '_blank';
  const filename = fileURL.substring(fileURL.lastIndexOf('/') + 1);
  save.download = fileName || filename;
  const evt = new MouseEvent('click', {
    view: window,
    bubbles: true,
    cancelable: false,
  });
  save.dispatchEvent(evt);
  (window.URL || window.webkitURL).revokeObjectURL(save.href);
};
